const B2C_WIDGET_PREFIX = "b2c_widget";
const EXPENSE_CODE_HALF_CARD = "expense_code_half_card";

export const B2C_WIDGET_TEST_IDS = {
    CONTAINER: `${B2C_WIDGET_PREFIX}_container`,
    WRAPPER: `${B2C_WIDGET_PREFIX}_wrapper`,
    ICON_CONTAINER: `${B2C_WIDGET_PREFIX}_icon_container`,
    CONTENT_WRAPPER: `${B2C_WIDGET_PREFIX}_content_wrapper`,
    TITLE: `${B2C_WIDGET_PREFIX}_title`,
    SUB_TEXT: `${B2C_WIDGET_PREFIX}_sub_text`,
    DISABLE_MESSAGE: `${B2C_WIDGET_PREFIX}_disable_message`,
    BALANCE_TEXT: `${B2C_WIDGET_PREFIX}_balance_text`,
    TOGGLE_SWITCH: `${B2C_WIDGET_PREFIX}_toggle_switch`,
};

export const EXPENSE_CODE_HALF_CARD_TEST_IDS = {
    CONTAINER: `${EXPENSE_CODE_HALF_CARD}_container`,
    TITLE: `${EXPENSE_CODE_HALF_CARD}_title`,
    DATA_CONTAINER: `${EXPENSE_CODE_HALF_CARD}_data_container`,
    PROJECT_CODE_INPUT: `${EXPENSE_CODE_HALF_CARD}_project_code_input`,
    PURPOSE_INPUT: `${EXPENSE_CODE_HALF_CARD}_purpose_input`,
    SUGGESTIONS_CONTAINER: `${EXPENSE_CODE_HALF_CARD}_suggestions_container`,
    NO_RESULTS_MESSAGE: `${EXPENSE_CODE_HALF_CARD}_no_results_message`,
    FOOTER: `${EXPENSE_CODE_HALF_CARD}_footer`,
    CTA_CONTAINER: `${EXPENSE_CODE_HALF_CARD}_cta_container`,
    SUBMIT_BUTTON: `${EXPENSE_CODE_HALF_CARD}_submit_button`,
    SUCCESS_CONTAINER: `${EXPENSE_CODE_HALF_CARD}_success_container`,
    SUCCESS_ICON: `${EXPENSE_CODE_HALF_CARD}_success_icon`,
    SUCCESS_TEXT: `${EXPENSE_CODE_HALF_CARD}_success_text`,
    TIMER_CONTAINER: `${EXPENSE_CODE_HALF_CARD}_timer_container`,
    TIMER_TEXT: `${EXPENSE_CODE_HALF_CARD}_timer_text`,
    DESCRIPTION_TEXT: `${EXPENSE_CODE_HALF_CARD}_description_text`,
};
